module.exports = __webpack_public_path__ + "media/images/smart_phone/toplogo_03-e4d254a44cd3cbd41ab6fcd21d3cb7d8.png";